"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidiseServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class LiquidiseServiceLive {
    tvl(companyId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/tvl`, { currentUser });
            return response.data;
        });
    }
    stake(companyId, currentUser, amount, shareClassId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/tvl/stake`, {
                currentUser,
                amount,
                shareClassId,
                shareholderId,
            });
            return response.data;
        });
    }
    liquidiseRun(companyId, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/liquidise-run`, parameters);
            return response.data;
        });
    }
    getDefaultFee(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/liquidise/default-fee`);
            return response.data;
        });
    }
    getLiquidityProviderHoldings(companyId, shareClassId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/liquidise/liquidity-provider-holdings/${shareClassId}`);
            return response.data;
        });
    }
    // Auction service
    getTradingWindow(companyId, auctionId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "auction",
                methodName: "get",
                parameters: [auctionId],
                currentUser,
            });
        });
    }
    setPriceLimits(companyId, tradingWindowId, floor, ceiling, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "auction",
                methodName: "setPriceLimits",
                parameters: [tradingWindowId, floor, ceiling],
                currentUser,
            });
        });
    }
    setPriceFixed(companyId, tradingWindowId, fixed, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "auction",
                methodName: "setPriceFixed",
                parameters: [tradingWindowId, fixed],
                currentUser,
            });
        });
    }
    acceptOffer(companyId, tradingWindowId, currentUser, shareholderId, acceptedLiquidiseTerms) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "auction",
                methodName: "acceptOffer",
                parameters: [tradingWindowId],
                currentUser,
                shareholderId,
                acceptedLiquidiseTerms,
            });
        });
    }
    rejectOffer(companyId, tradingWindowId, currentUser, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "auction",
                methodName: "rejectOffer",
                parameters: [tradingWindowId],
                currentUser,
                shareholderId,
            });
        });
    }
    // Enrolment service
    getUserAuctionEnrolments(companyId, tradingWindowId, shareholderId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "enrolment",
                methodName: "get",
                parameters: [tradingWindowId, shareholderId],
                currentUser,
            });
        });
    }
    // Offer service
    addOffer(companyId, tradingWindowId, shares, currentUser, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "offer",
                methodName: "add",
                parameters: [tradingWindowId, shares],
                currentUser,
                shareholderId,
            });
        });
    }
    getUserAuctionOffers(companyId, shareholderId, auctionId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "offer",
                methodName: "getUserAuctionOffers",
                parameters: [shareholderId, auctionId],
                currentUser,
            });
        });
    }
    // User service
    createUser(companyId, shareholderId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "users",
                methodName: "create",
                parameters: [shareholderId],
                currentUser,
            });
        });
    }
    getAllUsers(companyId, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "users",
                methodName: "getAll",
                parameters: [],
                currentUser,
            });
        });
    }
    getUserBalances(companyId, userId, currentUser, createIfNotExists = false, refresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            // Share class codes are now added server-side in the liquidiseRun controller
            // to avoid webpack bundling issues with mongoose/ODM SDK
            return this.liquidiseRun(companyId, {
                sectionName: "users",
                methodName: "getBalances",
                parameters: [userId, createIfNotExists, refresh],
                currentUser,
            });
        });
    }
    mintTokens(companyId, userId, amount, currentUser, createIfNotExists = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "users",
                methodName: "mintTokens",
                parameters: [userId, amount.toString(), createIfNotExists],
                currentUser,
            });
        });
    }
    burnTokens(companyId, userId, amount, currentUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.liquidiseRun(companyId, {
                sectionName: "users",
                methodName: "burnTokens",
                parameters: [userId, amount.toString()],
                currentUser,
            });
        });
    }
    redeemShareTokens(companyId, userId, amount, shareClassSymbol, sharePriceInCents, currentUser, bankAccountName, bsb, accountNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/redeem-shares`, {
                userId,
                amount: amount.toString(),
                shareClassSymbol,
                sharePriceInCents,
                bankAccountName,
                bsb,
                accountNumber,
            });
            return response.data;
        });
    }
    createRedemptionWindow(companyId, startDate, endDate, pricePerUnit, shareClassSymbol) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/redemption-windows`, {
                startDate,
                endDate,
                pricePerUnit,
                shareClassSymbol,
            });
            return response.data;
        });
    }
    getRedemptionWindows(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/liquidise/redemption-windows`);
            return response.data;
        });
    }
    getActiveRedemptionWindow(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/liquidise/redemption-windows/active`);
            return response.data;
        });
    }
    openRedemptionWindow(companyId, redemptionWindowId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/redemption-windows/open`, {
                redemptionWindowId,
            });
            return response.data;
        });
    }
    closeRedemptionWindow(companyId, redemptionWindowId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/redemption-windows/close`, {
                redemptionWindowId,
            });
            return response.data;
        });
    }
    getRedemptionRequests(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/liquidise/redemption-requests`);
            return response.data;
        });
    }
    confirmPayment(companyId, redemptionRequestId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/redemption-requests/confirm-payment`, {
                redemptionRequestId,
            });
            return response.data;
        });
    }
    debugBurnShareTokens(companyId, userId, shareClassSymbol, quantityInEth) {
        return __awaiter(this, void 0, void 0, function* () {
            // Convert to string to preserve precision for very large numbers
            const quantityStr = typeof quantityInEth === "string" ? quantityInEth : String(quantityInEth);
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/liquidise/debug/burn-share-tokens`, {
                userId,
                shareClassSymbol,
                quantityInEth: quantityStr,
            });
            return response.data;
        });
    }
}
exports.LiquidiseServiceLive = LiquidiseServiceLive;
//# sourceMappingURL=LiquidiseServiceLive.js.map